import React from 'react';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import Loader from '../../components/Loader';
import useDialogConfig from '../_hooks/useDialogConfig';
import EventDialog from '../event_view';

export default function Launcher(props) {
  const config = useDialogConfig();

  const event = useConnect('event.byId', {
    id: config.params.eventId
  });

  if (event.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <EventDialog
      event={event}
      onCancel={props.onClose}
    />
  );
};
